import { call, put, fork, takeLatest } from 'redux-saga/effects';
import * as wam from '@tcc/wam';
import {
  receiveCurrentUserDetails,
  failureCurrentUserDetails,
  receiveFeatures,
} from '../actions/currentUserActions';
import { REQUEST_CURRENT_USER_DETAILS } from '../constants/actionTypes';
import { requestUserDetails } from '../requesters/currentUserRequesters';
import { setUnitQty } from '../../i18n/unitQtyWrapper';
import { initialize as initializeFeatureFlags } from '../../utils/featureFlags';

export function* getCurrentUserDetails(action) {
  try {
    const requestedUserId =
      action.id || (wam.getUserData() && wam.getUserData().clientId);
    const userDetails = yield call(requestUserDetails, requestedUserId);
    setUnitQty(
      userDetails.preferences.unitsOfMeasureTemplateName,
      userDetails.countryCode
    );
    yield put(receiveCurrentUserDetails(userDetails));
    const { keys, values } = yield call(initializeFeatureFlags, requestedUserId, userDetails.countryCode);
    yield put(receiveFeatures(keys, values));
  } catch (error) {
    yield put(failureCurrentUserDetails(error));
  }
}

export function* getCurrentUserDetailsWatcher() {
  yield takeLatest(REQUEST_CURRENT_USER_DETAILS, getCurrentUserDetails);
}

export default function* rootSaga() {
  yield fork(getCurrentUserDetailsWatcher);
}
